import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Message } from '../services/websocketApi';

type GlobalState = {
    messages: Record<string, Message[]>; // messages per topic
    config: Record<string, any>; // config per topic
};

const initialState: GlobalState = { messages: {}, config: {} };

export const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        addMessage: (state, action: PayloadAction<{ topic: string; message: Message }>) => {
            const { topic, message } = action.payload;
            if (!state.messages[topic]) state.messages[topic] = [];
            state.messages[topic].push(message);
            // Limit to last 100 messages per topic
            if (state.messages[topic].length > 100) state.messages[topic].shift();
        },
        updateConfig: (state, action: PayloadAction<{ topic: string; config: any }>) => {
            const { topic, config } = action.payload;
            state.config[topic] = { ...state.config[topic], ...config };
        },
    },
});

export const { addMessage, updateConfig } = globalSlice.actions;
export default globalSlice.reducer;
